import React, { useEffect, useState } from 'react';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { api_cep } from '../services/apis';

const AdicionarLocatarioModal = ({ show, onClose, onSave, locatarioEditando, verificaPessoa }) => {
    const [locatarioCpfCnpj, setLocatarioCpfCnpj] = useState('');
    const [avisoTxt, setAvisoTxt] = useState('');
    const [locatarioId, setLocatarioId] = useState(0);
    const [locatarioNome, setLocatarioNome] = useState('');
    const [locatarioRgIe, setLocatarioRgIe] = useState('');
    const [locatarioEmail, setLocatarioEmail] = useState('');
    const [locatarioTelefone, setLocatarioTelefone] = useState('');
    const [locatarioCelular, setLocatarioCelular] = useState('');
    const [locatarioCep, setLocatarioCep] = useState('');
    const [locatarioEndereco, setLocatarioEndereco] = useState('');
    const [locatarioBairro, setLocatarioBairro] = useState('');
    const [locatarioCidade, setLocatarioCidade] = useState('');
    const [locatarioEstado, setLocatarioEstado] = useState('');
    const [locatarioNumero, setLocatarioNumero] = useState('');
    const [locatarioComplemento, setLocatarioComplemento] = useState('');


    useEffect(() => {
        if (locatarioEditando) {
          setLocatarioId(locatarioEditando.id);
          setLocatarioCpfCnpj(locatarioEditando.cpf_cnpj || '');
          setLocatarioNome(locatarioEditando.nome || '');
          setLocatarioRgIe(locatarioEditando.rg_ie || '');
          setLocatarioEmail(locatarioEditando.email || '');
          setLocatarioTelefone(locatarioEditando.telefone || '');
          setLocatarioCelular(locatarioEditando.celular || '');
          setLocatarioCep(locatarioEditando.cep || '');
          setLocatarioEndereco(locatarioEditando.endereco || '');
          setLocatarioBairro(locatarioEditando.bairro || '');
          setLocatarioCidade(locatarioEditando.cidade || '');
          setLocatarioEstado(locatarioEditando.estado || '');
          setLocatarioNumero(locatarioEditando.numero || '');
          setLocatarioComplemento(locatarioEditando.complemento || '');
        }
      }, [locatarioEditando]);
      
    const preencheu = (name) => {
        if (document.getElementsByName(name)[0]?.classList.contains('form--error')) {
            document.getElementsByName(name)[0].classList.remove('form--error');
        }
    };

    const verificarPessoa = async (cpf_cnpj_formatado) => {
        const pessoa = await verificaPessoa(cpf_cnpj_formatado)
        return pessoa;
    };

    const changeCpfCnpj = async (event) => {
        preencheu('locatario_cpf_cnpj');

        const input = event.target.value.replace(/[^\d]/g, '');
        let cpf_cnpj;

        if (input.length <= 11) {
            cpf_cnpj = input.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else {
            cpf_cnpj = input.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }

        setLocatarioCpfCnpj(cpf_cnpj);

        if (input.length >= 11 && input.length <= 14) {
            let aviso = '';
            if (input.length === 11 && !cpf.isValid(input)) aviso = 'CPF inválido';
            if (input.length === 14 && !cnpj.isValid(input)) aviso = 'CNPJ inválido';

            setAvisoTxt(aviso);

            const pessoa = await verificarPessoa(cpf_cnpj);
            console.log(pessoa)
            if (pessoa) {
                setLocatarioId(pessoa.id);
                setLocatarioNome(pessoa.nome);
                setLocatarioRgIe(pessoa.rg_ie);
                setLocatarioEmail(pessoa.email);
                setLocatarioTelefone(pessoa.telefone);
                setLocatarioCelular(pessoa.celular);
                setLocatarioCep(pessoa.cep);
                setLocatarioEndereco(pessoa.endereco);
                setLocatarioBairro(pessoa.bairro);
                setLocatarioCidade(pessoa.cidade);
                setLocatarioEstado(pessoa.uf);
                setLocatarioNumero(pessoa.numero);
                setLocatarioComplemento(pessoa.complemento);
            }
        } else {
            setAvisoTxt('');
            setLocatarioId(0);
            setLocatarioNome('');
            setLocatarioRgIe('');
            setLocatarioEmail('');
            setLocatarioTelefone('');
            setLocatarioCelular('');
            setLocatarioCep('');
            setLocatarioEndereco('');
            setLocatarioBairro('');
            setLocatarioCidade('');
            setLocatarioEstado('');
            setLocatarioNumero('');
            setLocatarioComplemento('');
        }
    };

    const changeCepLocatario = (event) => {
        preencheu('locatario_cep');
        const cepDigitado = event.target.value.replace(/\D/g, '');
    
        if (cepDigitado.length === 8) {
            api_cep.get(`/${cepDigitado}/json`).then((dados_cep) => {
                setLocatarioCep(dados_cep.data.cep || '');
                setLocatarioEndereco(dados_cep.data.logradouro || '');
                setLocatarioBairro(dados_cep.data.bairro || '');
                setLocatarioCidade(dados_cep.data.localidade || '');
                setLocatarioEstado(dados_cep.data.uf || '');
                setLocatarioNumero('');
                setLocatarioComplemento('');
            }).catch(() => {
                setAvisoTxt('CEP não encontrado');
                setLocatarioEndereco('');
                setLocatarioBairro('');
                setLocatarioCidade('');
                setLocatarioEstado('');
                setLocatarioNumero('');
                setLocatarioComplemento('');
            });
        } else {
            setLocatarioCep(event.target.value);
            setLocatarioEndereco('');
            setLocatarioBairro('');
            setLocatarioCidade('');
            setLocatarioEstado('');
            setLocatarioNumero('');
            setLocatarioComplemento('');
        }
    };
    

    const handleSave = () => {
        if (!locatarioCpfCnpj || !locatarioNome || !locatarioEmail ||
            !locatarioCep || !locatarioEndereco || !locatarioNumero ||
            !locatarioBairro || !locatarioCidade || !locatarioEstado) {
            alert('Por favor, preencha todos os campos obrigatórios');
            return;
        }

        const novoLocatario = {
            id: locatarioId !== 0 ? locatarioId : 0,
            cpf_cnpj: locatarioCpfCnpj,
            nome: locatarioNome,
            rg_ie: locatarioRgIe,
            email: locatarioEmail,
            telefone: locatarioTelefone,
            celular: locatarioCelular,
            cep: locatarioCep,
            endereco: locatarioEndereco,
            bairro: locatarioBairro,
            cidade: locatarioCidade,
            estado: locatarioEstado,
            numero: locatarioNumero,
            complemento: locatarioComplemento
        };

        onSave(novoLocatario);

        setLocatarioCpfCnpj('');
        setAvisoTxt('');
        setLocatarioId(0);
        setLocatarioNome('');
        setLocatarioRgIe('');
        setLocatarioEmail('');
        setLocatarioTelefone('');
        setLocatarioCelular('');
        setLocatarioCep('');
        setLocatarioEndereco('');
        setLocatarioBairro('');
        setLocatarioCidade('');
        setLocatarioEstado('');
        setLocatarioNumero('');
        setLocatarioComplemento('');

        onClose();
    };

    return (
        show && (
            <div
                style={{
                    position: 'fixed',
                    top: 0, left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 1050,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflowY: 'auto',
                    padding: '20px'
                }}
                onClick={onClose}
            >
                <div className="modal-dialog modal-xl" onClick={(e) => e.stopPropagation()}
                    style={{ width: '100%', maxWidth: '1000px' }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title wizard__p">Adicionar Locatário</h5>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_cpf_cnpj`}>
                                            <label style={{ width: '100%' }}>CPF/CNPJ: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    maxLength={18}
                                                    value={locatarioCpfCnpj}
                                                    onChange={changeCpfCnpj}
                                                />
                                            </div>
                                            <span>{avisoTxt}</span>
                                        </div>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='grupo__campo' name={`locatario_nome`}>
                                            <label style={{ width: '100%' }}>Nome: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioNome}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_nome`);
                                                        setLocatarioNome(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo'>
                                            <label style={{ width: '100%' }}>RG: </label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioRgIe}
                                                    onChange={(event) => {
                                                        setLocatarioRgIe(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='grupo__campo' name={`locatario_email`}>
                                            <label style={{ width: '100%' }}>Email: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioEmail}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_email`);
                                                        setLocatarioEmail(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo'>
                                            <label style={{ width: '100%' }}>Telefone: </label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioTelefone}
                                                    onChange={(event) => {
                                                        setLocatarioTelefone(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo'>
                                            <label style={{ width: '100%' }}>Celular: </label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioCelular}
                                                    onChange={(event) => {
                                                        setLocatarioCelular(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_cep`}>
                                            <label style={{ width: '100%' }}>CEP: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioCep}
                                                    onChange={changeCepLocatario}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='grupo__campo' name={`locatario_endereco`}>
                                            <label style={{ width: '100%' }}>Endereço: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioEndereco}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_endereco`);
                                                        setLocatarioEndereco(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_numero`}>
                                            <label style={{ width: '100%' }}>Número: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioNumero}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_numero`);
                                                        setLocatarioNumero(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo'>
                                            <label style={{ width: '100%' }}>Complemento: </label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioComplemento}
                                                    onChange={(event) => {
                                                        setLocatarioComplemento(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_bairro`}>
                                            <label style={{ width: '100%' }}>Bairro: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioBairro}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_bairro`);
                                                        setLocatarioBairro(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_cidade`}>
                                            <label style={{ width: '100%' }}>Cidade: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <input
                                                    type='text'
                                                    value={locatarioCidade}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_cidade`);
                                                        setLocatarioCidade(event.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='grupo__campo' name={`locatario_estado`}>
                                            <label style={{ width: '100%' }}>Estado: *</label><br />
                                            <div className='grupo__campo__form'>
                                                <select
                                                    value={locatarioEstado}
                                                    onChange={(event) => {
                                                        preencheu(`locatario_estado`);
                                                        setLocatarioEstado(event.target.value);
                                                    }}
                                                >
                                                    <option>Selecione</option>
                                                    <option value='AC'>Acre</option>
                                                    <option value='AL'>Alagoas</option>
                                                    <option value='AP'>Amapá</option>
                                                    <option value='AM'>Amazonas</option>
                                                    <option value='BA'>Bahia</option>
                                                    <option value='CE'>Ceará</option>
                                                    <option value='DF'>Distrito Federal</option>
                                                    <option value='ES'>Espírito Santo</option>
                                                    <option value='GO'>Goiás</option>
                                                    <option value='MA'>Maranhão</option>
                                                    <option value='MT'>Mato Grosso</option>
                                                    <option value='MS'>Mato Grosso do Sul</option>
                                                    <option value='MG'>Minas Gerais</option>
                                                    <option value='PA'>Pará</option>
                                                    <option value='PB'>Paraíba</option>
                                                    <option value='PR'>Paraná</option>
                                                    <option value='PE'>Pernambuco</option>
                                                    <option value='PI'>Piauí</option>
                                                    <option value='RJ'>Rio de Janeiro</option>
                                                    <option value='RN'>Rio Grande do Norte</option>
                                                    <option value='RS'>Rio Grande do Sul</option>
                                                    <option value='RO'>Rondônia</option>
                                                    <option value='RR'>Roraima</option>
                                                    <option value='SC'>Santa Catarina</option>
                                                    <option value='SP'>São Paulo</option>
                                                    <option value='SE'>Sergipe</option>
                                                    <option value='TO'>Tocantins</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="wizard__dots">
                            <button className="button btn__primary--outline" onClick={onClose}>Fechar</button>
                            <button className="button btn__primary" onClick={handleSave}>Salvar Locatário</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default AdicionarLocatarioModal;